import { createMutationHelper } from '@utils/swr'
import { type PaymentTransactionRequest, type FastpassPaymentTransactionRequest } from '../types/apiRequest'
import { type MerchantCancelTransactionResponse } from '../types/apiResponse'
import { type ECommerceV2Apis, type FortuneApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<FortuneApis['delete']['cancelPaymentTransactions'], MerchantCancelTransactionResponse, FastpassPaymentTransactionRequest>({
  client: 'fortune',
  key: '/m/payment_transactions',
  fetcher: (url, { arg, client }) => {
    return client.delete(`${url}/${arg.id}`)
  },
})

export const useApiCancelPaymentTransaction = useMutation

export const {
  useMutation: useECommerceCancelPaymentTransaction,
} = createMutationHelper<ECommerceV2Apis['delete']['cancelPaymentTransactions'], MerchantCancelTransactionResponse, PaymentTransactionRequest>({
  client: 'eCommerceV2',
  key: '/:countryCode/payment_transactions',
  fetcher: (_, { arg, client }) => {
    return client.delete(`/${arg.country_code}/payment_transactions/${arg.id}`)
  },
})
